<script>
import Switches from "vue-switches";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      treatments: []
    }
  },
  components: { Switches },
  mounted() {
    this.fetchTreatments()
  },
  methods: {
    fetchTreatments() {
      this.$axios.get(`employee/${this.$route.params.id}/treatment`)
        .then( response => {
          this.treatments = response.data.result.treatments
        })
    },
    onSubmit() {
      let param = new FormData()
      this.treatments.forEach( eq => {
        if(eq.isPresent === true){
          param.append('treatments', eq.treatmentId)
        }
      })
      
      this.$axios.put(`employee/${this.$route.params.id}/treatment`, param)
        .then( () => {
          Swal.fire("Success", "Employee Treatment Updated Successfully", "success");
        })
    }
  }
}
</script>

<template>
  <div id="edit-treatment">
    <div class="table-responsive mb-0">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%">No</th>
            <th style="width: 85%">Name</th>
            <th style="width: 10%">Handle</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(treatment, index) in treatments" :key="index">
            <th scope="row">{{ index+1 }}</th>
            <td>{{ treatment.name }}</td>
            <td>
              <switches v-model="treatment.isPresent" type-bold="false" color="warning" class="ml-1 mb-0"></switches>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" @click="onSubmit" class="btn btn-primary m-1 float-right">Submit Change</button>
    </div>
  </div>
</template>